import request from '@/axios'

// 新增员工

// 删除角色

// 查询菜单
export const pageConfigList = () => {
  return request.get('/mt/sales/config/pageMenus')
}

// 应用列表
export const basicAppList = (data: any) => {
  return request.post('/subgrade/basic/app/list', data, 'json')
}

// 销售员列表
export const salesmanList = (data): any => {
  return request.post(`/mt/sales/customer/salesman/list`, data, 'json')
}
